import React from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Footer from "../../components/footer/footer";
import InvestmentPagePlan from "../../components/investementPagePlan/investmentPagePlan";
import LatestTransactions from "../../components/latestTransactions/latestTransactions";

export default function Investment() {
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-lg-9 col-md-9 col-12 col-sm-8">
                <h1>Investment plan </h1>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-4">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>Investment </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <InvestmentPagePlan />
      <LatestTransactions />
      <Footer />
    </div>
  );
}
